import LoginSideBar from "../../components/common/LoginSidebar";
import SignupForm from "../../components/signup/SignupForm";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { isLoggedIn } from "../../components/authProvider/AuthContext";


const Signup = () => {
  const navigate = useNavigate();

  useEffect (() => {
  if(isLoggedIn()) {
      navigate('/dashboard')
  }
  });

  return (
    <div className="flex h-screen p-8">
      <div className="lg:w-[60%] lg:block hidden">
          <LoginSideBar />
      </div>
      <div className="lg:w-[40%] w-full text-center h-[100%] flex flex-col items-center justify-center mb-14">
          <SignupForm />
      </div>
    </div>
  );
}

export default Signup;
